import React, { useState } from 'react';

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import { Link } from 'react-router-dom';

import { ReactComponent as HelpIcon } from '../../../assets/icons/ic_help.svg';
import { ReactComponent as KakaotalkIcon } from '../../../assets/icons/ic_kakaotalk.svg';
import { ReactComponent as MailIcon } from '../../../assets/icons/ic_mail.svg';
import { ReactComponent as SupportIconSVG } from '../../../assets/icons/ic_support.svg';
import { ReactComponent as WhatsappIcon } from '../../../assets/icons/ic_whatsapp.svg';

const SupportIcon = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <SupportIconSVG
          className={`cursor-pointer ${isOpen ? 'text-primary' : ''}`}
          width={24}
          height={24}
          aria-label="Support"
        />
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-[400px] rounded-lg bg-white p-5">
        <div className="flex w-full flex-col bg-white">
          <h4 className="mb-4 flex items-center text-b3">Support</h4>

          <div className="flex w-full flex-col gap-y-1.5">
            <DropdownMenuItem>
              <Link
                to={'mailto:official@checkmatekorea.com'}
                className="flex cursor-pointer items-center gap-x-[5px] text-b4"
                onClick={() => {
                  window.dataLayer?.push({
                    event: 'click_menu',
                    menu: 'mail',
                    section: 'Service menu',
                  });
                }}
              >
                <MailIcon width={32} height={32} aria-label="Mail" />
                <span>official@checkmatekorea.com</span>
              </Link>
            </DropdownMenuItem>

            <DropdownMenuItem
              className="flex cursor-pointer items-center gap-x-[5px] text-b4"
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_menu',
                  menu: 'kakao',
                  section: 'Service menu',
                });
                window.open('http://pf.kakao.com/_xjSxcxgxj', '_blank');
              }}
            >
              <KakaotalkIcon width={32} height={32} aria-label="Contact us via KakaoTalk" />
              <span>Contact us via KakaoTalk</span>
            </DropdownMenuItem>

            <DropdownMenuItem
              className="flex cursor-pointer items-center gap-x-[5px] text-b4"
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_menu',
                  menu: 'whatsapp',
                  section: 'Service menu',
                });
                window.open('https://wa.me/821087033395', '_blank');
              }}
            >
              <WhatsappIcon width={32} height={32} aria-label="Whatsapp" />
              <span>Contact us via Whatsapp</span>
            </DropdownMenuItem>

            <DropdownMenuItem
              className="flex cursor-pointer items-center gap-x-[5px] text-b4"
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_menu',
                  menu: 'help',
                  section: 'Service menu',
                });
                window.open(
                  'https://buttercup-coral-e9a.notion.site/Help-Center-a65dec1c44ca44958a2d192d5119017e?pvs=4',
                  '_blank',
                );
              }}
            >
              <HelpIcon width={32} height={32} aria-label="Help Center" />
              <span>Help Center</span>
            </DropdownMenuItem>
          </div>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SupportIcon;
